import { Cancel } from '@mui/icons-material';
import { Box, Card, IconButton, Typography } from '@mui/material';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { PromotionRequiredDishesCombination } from '../../apiTypes';
import { t } from '../../constants/translations';
import { useLocale } from '../../contexts/locale.context';
import PrimaryButton from '../PrimaryButton';
import FormDishesBundle from './FormDishesBundle';

type FormType = Record<string, PromotionRequiredDishesCombination[]>;

export type Props = {
  name: string;
};

const FormDishesBundles = ({ name }: Props) => {
  const { lang } = useLocale();
  const { control } = useFormContext();

  const { fields, append, remove } = useFieldArray<FormType>({
    control,
    name,
    keyName: 'id',
  });

  return (
    <Box>
      {fields.map((_, index) => (
        <Box key={index} sx={{ mb: index === fields.length - 1 ? 1 : 2 }}>
          <Card variant="outlined" sx={{ p: 0.5, pt: 1, position: 'relative', overflow: 'visible' }}>
            <Typography
              variant="body2"
              sx={{
                px: 0.5,
                position: 'absolute',
                top: -10,
                left: 12,
                backgroundColor: (t) => t.palette.background.paper,
                color: (t) => t.palette.text.secondary,
              }}
            >
              {t.combination[lang]} {index + 1}
            </Typography>
            <IconButton size="small" onClick={() => remove(index)} sx={{ position: 'absolute', top: -14, right: -14 }}>
              <Cancel fontSize="small" />
            </IconButton>
            <FormDishesBundle name={`${name}[${index}].items`} />
          </Card>
        </Box>
      ))}

      <PrimaryButton size="small" onClick={() => append({ index: fields.length + 1, items: [] })}>
        {t.add_combination[lang]}
      </PrimaryButton>
    </Box>
  );
};

export default FormDishesBundles;
